// @flow
import React, { useState } from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { RestaurantActions } from 'modules/restaurant/actions';
import { useViewport } from 'components/templates/viewportProvider';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { RouteNames } from 'router';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  restaurantCategories: Array,
  craftBeerSectionData: Array,
  merchandiseLink: Array,
  reservationLink: Array,
  upcomingShows: Array,
  orderLink: Array,
  teamData: Array,
  joinLink: string,
};

const RestaurantHeaderButtons = (props: Props) => {
  const { isMobile } = useViewport();
  const {
    restaurantCategories,
    craftBeerSectionData,
    merchandiseLink,
    reservationLink,
    upcomingShows,
    orderLink,
    joinLink,
    teamData,
    toggleModal,
    restaurantName,
    location,
    data,
  } = props;

  const [form, showForm] = useState(false);

  const handleClick = link => {
    window.open(link);
  };

  const showModal = val => {
    toggleModal(val);
  };

  const openFormOverlay = () => {
    showForm(true);
    // showModal(false);
  };

  let extractedData = '';
  data &&
    data.banner.map(data => {
      extractedData = data;
    });

  const showOverlay = form ? (
    <OverlayPortal>
      <OverlayModal
        data={extractedData}
        theme={'light-theme'}
        type={'reservation-form'}
        onClosePress={() => showForm(false)}
        location={location}
        formData={data}
        breadcrumbList={[
          {
            breadcrumbName: 'Restaurant',
            breadcrumbLink: RouteNames.restaurants,
          },
          {
            breadcrumbName: restaurantName,
            breadcrumbLink: '#',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  //TODO: refactor
  return (
    <>
      <Breadcrumb>
        <div className={'restaurant-header-buttons'}>
          {!isEmpty(restaurantCategories) &&
            (isMobile ? (
              <h2 onClick={() => showModal(false)}>
                <a href={'#menu'}>Menu</a>
              </h2>
            ) : (
              <h4 onClick={() => showModal(false)}>
                <a href={'#menu'}>Menu</a>
              </h4>
            ))}
          {!isEmpty(craftBeerSectionData) &&
            (isMobile ? (
              <h2 onClick={() => showModal(false)}>
                <a href={'#brewery'}>Brewery</a>
              </h2>
            ) : (
              <h4>
                <a href={'#brewery'}>Brewery</a>
              </h4>
            ))}
          {!isEmpty(upcomingShows) &&
            (isMobile ? (
              <h2 onClick={() => showModal(false)}>
                <a href={'#foundation'}>Music</a>
              </h2>
            ) : (
              <h4>
                <a href={'#foundation'}>Music</a>
              </h4>
            ))}
          {!isEmpty(merchandiseLink) &&
            (isMobile ? (
              <h2
                onClick={() => {
                  handleClick(merchandiseLink[0].merchandiseLink);
                  showModal(false);
                }}
              >
                Merchandise
              </h2>
            ) : (
              <h4
                onClick={() => handleClick(merchandiseLink[0].merchandiseLink)}
              >
                Merchandise
              </h4>
            ))}
          {!isEmpty(orderLink) &&
            (isMobile ? (
              <h2
                onClick={() => {
                  handleClick(orderLink[0].orderOnlineLink);
                  showModal(false);
                }}
              >
                Order Online
              </h2>
            ) : (
              <h4 onClick={() => handleClick(orderLink[0].orderOnlineLink)}>
                Order Online
              </h4>
            ))}
          {isMobile ? (
            <h2 onClick={openFormOverlay}>Reservations</h2>
          ) : (
            <h4 onClick={openFormOverlay}>Reservations</h4>
          )}
          {!isEmpty(teamData) &&
            joinLink &&
            (isMobile ? (
              <h2
                onClick={() => {
                  handleClick(joinLink);
                  showModal(false);
                }}
              >
                Careers
              </h2>
            ) : (
              <h4 onClick={() => handleClick(joinLink)}>Careers</h4>
            ))}
        </div>
      </Breadcrumb>
      {showOverlay}
    </>
  );
};

const mapDispatchToProps = dispatch => {
  const { toggleModal } = RestaurantActions;
  return bindActionCreators(
    {
      toggleModal,
    },
    dispatch
  );
};

const connectedComponent = connect(
  null,
  mapDispatchToProps
)(RestaurantHeaderButtons);

export default connectedComponent;
